<template>
  <v-card class="mx-0">
    <v-card-title>
      <span class="title ml-2 mt-2">{{ $t('message.entity.history.contentTitle') }}</span>
    </v-card-title>
    <v-card-text style="min-height: 300px" class="mx-0">
      <nx-content-version-selector
        v-if="active"
        :id="id"
        :value="selectedRelativeVersionId"
        :language="language"
        @input="onVersionSelected">
      </nx-content-version-selector>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="dismiss">
        {{ $t('message.common.close') }}
      </v-btn>
      <v-btn
        flat
        color="accent"
        @click="restore"
        :disabled="!selectedRelativeVersionId
        || selectedRelativeVersionId === relativeVersionId">
        {{ $t('message.content.tools.actionsLog.restoreVersion') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>


import NxContentVersionSelector from '@/modules/content/editor/components/version/ContentVersionSelector';

export default {
  name: 'nx-content-version-navigator',
  components: {
    NxContentVersionSelector,
  },
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    relativeVersionId: {
      type: Number,
      required: true,
    },
    language: {
      type: String,
    },
  },
  data() {
    return {
      selectedVersion: null,
    };
  },
  computed: {
    selectedRelativeVersionId() {
      if (this.selectedVersion) return this.selectedVersion.relativeVersionId;
      return this.relativeVersionId;
    },
  },
  methods: {
    onVersionSelected(entityVersion) {
      this.selectedVersion = entityVersion;
    },
    restore() {
      this.$emit('close');
      this.$emit('updateRelativeVersionId', this.selectedRelativeVersionId);
    },
    dismiss() {
      this.selectedVersion = null;
      this.$emit('close');
    },
  },
};
</script>
